import { render, staticRenderFns } from "./LocationDaesanPage.vue?vue&type=template&id=3b6bad21&scoped=true&"
import script from "./LocationDaesanPage.vue?vue&type=script&lang=js&"
export * from "./LocationDaesanPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6bad21",
  null
  
)

export default component.exports